export enum ApplicationResolution {
  HD = '720p',
  FULLHD = '1080p',
}

export function createApplicationResolution(
  from: string
): ApplicationResolution {
  return from === '1080p'
    ? ApplicationResolution.FULLHD
    : ApplicationResolution.HD;
}

export const rootFontSize = {
  [ApplicationResolution.HD]: 16,
  [ApplicationResolution.FULLHD]: 24,
};
